import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class PollinationCategoryService {
  constructor(private apiHttp: ApiHttpService) { }

  public getAll = (): Observable<PollinationCategory[]> => {
    return this.apiHttp.get<PollinationCategory[]>("pollinationcategories");
  };

  public get = (id: number): Observable<PollinationCategory> => {
    return this.apiHttp.get<PollinationCategory>(`pollinationcategories/${id}`);
  };
}

export interface PollinationCategory {
  id: number;
  name: string;
  isActive: boolean;
  order: number;
  numberOfPreferenceGroups: number;
  numberOfInstructionsPerPair: number;
}

export enum PollinationCategoryEnum {
  Standard = 1,
  ZygosityDependent = 2,
  CrossingBlock = 3
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/pollination-category.service.ts